import { render, staticRenderFns } from "./FoldersSettings.vue?vue&type=template&id=6ad73ab4&scoped=true&"
import script from "./FoldersSettings.vue?vue&type=script&lang=js&"
export * from "./FoldersSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad73ab4",
  null
  
)

export default component.exports